import { Card } from "@mui/material"
import Businesses from "./Home/Business";
import Profile from "./Home/Profile";
import EditProfile from "./Home/EditProfile";
import ConfirmEmail from "./Home/ConfirmEmail";
import { useCookies } from 'react-cookie';
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ConfirmPhoneNumber from "./Home/ConfirmPhoneNumber";
import { getStepRedux, setStepRedux } from "../libs/profileSlice";
import { useDispatch, useSelector } from "react-redux";
import FadeIn from "react-fade-in/lib/FadeIn"
import { getCurrentRole } from "../libs/todoSlice";


const Home = () => {
  const [cookie, setCookie, removeCookie] = useCookies(['account'])
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const step = useSelector(getStepRedux)

  useEffect(() => {
    

    setStep("profile")
  }, [cookie]);

  const setStep = (action) => {
    dispatch(setStepRedux({
      step: action
    }))
  }

  const currentRole = useSelector(getCurrentRole)

  return (<FadeIn>

    {
      {
        "profile": (
          <>
            <div style={{ backgroundColor: 'rgb(248, 249, 250)', padding: '30px' }}>
              <div className="container" style={{ backgroundColor: 'white', padding: '60px', borderRadius: '20px' }}>
                {
                  (currentRole === 'RA' || currentRole === 'owner') &&
                  <Profile />
                }
                <Businesses />
              </div>
            </div>
          </>
        ),
        "editprofile": (
          <div style={{ backgroundColor: 'rgb(248, 249, 250)', padding: '30px' }}>
            <div className="container" style={{ backgroundColor: 'white', padding: '60px', borderRadius: '20px' }}>
              <EditProfile />
            </div>
          </div>),
        "confirmemail": (
          <ConfirmEmail />
        ),
        "confirmphonenumber": (
          <ConfirmPhoneNumber />
        ),
      }[step]
    }

  </FadeIn>


    // <ConfirmPhoneNumber />
  )

}

export default Home